import { render } from "./VueDialog.vue?vue&type=template&id=12ed447d"
import script from "./VueDialog.vue?vue&type=script&lang=js"
export * from "./VueDialog.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__